export const KeyCode = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,

  SPACEBAR: 32,
  ENTER: 13,
  DELETE: 46,
  SHIFT: 16,
  CONTROL: 17,
  ALT: 18,
  META: 224,
  ESCAPE: 27,
  BACKSPACE: 8,

  OPEN_SQ_BRACKET: 219,
  CLOSE_SQ_BRACKET: 221,

  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  H: 72,
  I: 73,
  J: 74,
  K: 75,
  L: 76,
  M: 77,
  N: 78,
  O: 79,
  P: 80,
  Q: 81,
  R: 82,
  S: 83,
  T: 84,
  U: 85,
  V: 86,
  W: 87,
  X: 88,
  Y: 89,
  Z: 90
};

export const TABS = {
  EXTERNAL_FILES: {LABEL: 'EXTERNAL FILES', KEY: 'EXTERNAL_FILES'},
  HOME: {LABEL : 'HOME', KEY: 'HOME'},
  ASSETS: {LABEL : 'ASSETS', KEY: 'ASSETS'},
  COLLECTIONS: {LABEL : 'COLLECTIONS', KEY : 'COLLECTIONS'},
  REPORTING: {LABEL: 'REPORTING', KEY : 'REPORTING'}
};

export const BROWSE_EXT_CONSTANT = {
  NODE_TYPE : {
    FILE : 'FILE',
    FOLDER : 'FOLDER'
  },
  STATUS : {
    INGESTED: 'INGESTED',
    NOT_INGESTED : 'NOT-INGESTED'
  },
  KEYS : {
    ROOT: '/'
  }
};

export const PdfPreviewOption = {
  PAGE_BY_PAGE: 'PAGE_BY_PAGE',
  CONTINUOUS: 'CONTINUOUS'
};

export const pdfPreviewOptions = [
  { value: PdfPreviewOption.PAGE_BY_PAGE, label: 'Page by Page' },
  { value: PdfPreviewOption.CONTINUOUS, label: 'Continuous Page' }
];

export const fontFamilyOptions = [
  { value: 'Arial', label: 'Arial' },
  { value: 'Courier New', label: 'Courier New' },
  { value: 'Helvetica', label: 'Helvetica' },
  { value: 'Times New Roman', label: 'Times New Roman' }
];

export const advSrchMatchStrOptions = [
  {value: 'CONTAINS', label: 'Contains'},
  {value: 'NOT_CONTAINS', label: 'Not Contains'},
  {value: 'BEGINS_WITH', label: 'Begins With'},
  {value: 'ENDS_WITH', label: 'Ends With'},
  {value: 'EXACT', label: 'Matches Exactly'}
];

export const CommentFilterOption = {
  UNRESOLVED: 'UNRESOLVED',
  RESOLVED: 'RESOLVED',
  ALL: 'ALL'
};

export const CommentSortOption = {
  BY_MODIFICATION_DATE: 'BY_MODIFICATION_DATE',
  BY_DATE_ADDED: 'BY_DATE_ADDED',
  BY_AUTHOR: 'BY_AUTHOR',
  BY_VIDEO_TIME: 'BY_VIDEO_TIME'
};

export const Visibility = {
  VISIBLE: 'VISIBLE',
  HIDDEN: 'HIDDEN',
  HIDING: 'HIDING',
  SHOWING: 'SHOWING'
};

export const DownloadType = { ORIGINAL: 1, PDF: 2, ZIP: 3 };

const MIN_15 = 1000 * 60 * 15;
const MIN_30 = MIN_15 * 2;
const HR_1 = MIN_30 * 2;
const HR_2 = HR_1 * 2;
const HR_4 = HR_2 * 2;
const DAY_1 = HR_4 * 6;
const DAY_2 = DAY_1 * 2;
const DAY_7 = DAY_1 * 7;

export const SEND_NOTIFICATION_TIME_OPTIONS = [
  { value: MIN_15, label: '15 minutes before' },
  { value: MIN_30, label: '30 minutes before' },
  { value: HR_1, label: '1 hour before' },
  { value: HR_2, label: '2 hours before' },
  { value: HR_4, label: '4 hours before' },
  { value: DAY_1, label: '1 day before' },
  { value: DAY_2, label: '2 days before' }
];

export const S3_LINK_EXPIRE_TIME_OPTIONS = [
  { value: HR_2, label: '2 hours' },
  { value: DAY_1, label: '24 hours' },
  { value: DAY_2, label: '48 hours' },
  { value: DAY_7, label: '7 days' }
];

export const PAGE_SIZE = 60;

export const FetchPolicy = {
  CACHE_FIRST: 'CACHE_FIRST',
  CACHE_AND_NETWORK: 'CACHE_AND_NETWORK'
};

export const DATE_FORMAT = 'M/D/Y';
export const DATETIME_FORMAT = 'M/D/Y h:mmA';

export const SORT_BY_KIND = 'KIND';
export const SORT_BY_MTIME = 'MODIFICATION_TIME';

export const SEARCH_TAB = 'SEARCH'; //For search tab constant

export const WAVEPLAYER_DRAWING = 'WAVEPLAYERDRAWING';

//session maintain
export const HISTORY_BEGIN_URL = 'HISTORY_BEGIN_URL';
export const HISTORY_END_URL = 'HISTORY_END_URL';

//Advance Search Constants
export const METADATA_KEYS = 'METADATA_KEYS';
export const METADATA_VALUES = 'METADATA_VALUES';
export const METADATA_LOGICAL_RELATIONSHIPS = 'METADATA_LOGICAL_RELATIONSHIPS';
export const SEARCH_STRING = 'SEARCH_STRING';
export const FILE_NAME_MATCH_ENUM = 'FILE_NAME_MATCH_ENUM';
export const VALUE_LENGTH = 'VALUE_LENGTH';
export const HIDE = 'HIDE';
export const PIN_TO_TOP = 'PIN_TO_TOP';
export const SHOW_ALL = 'SHOW_ALL';
export const PATH_PROJECT = 'PATH_PROJECT';
export const AUTHOR = 'AUTHOR';
export const FILE_TYPE = 'FILE_TYPE';
export const CHECK_IN_DATE_RANGE = 'CHECK_IN_DATE_RANGE';
export const COMMENTS = 'COMMENTS';
export const WIDTH_OF_FOLDER_NAV = 'WIDTH_OF_FOLDER_NAV';
export const Q = 'q';
//Asset VAB Status
export const MODIFIED = 'MODIFIED';
export const NOCHANGE = 'NOCHANGE';
export const ADDED = 'ADDED';
export const SYNCED = 'SYNCED';
export const UNVERSIONED = 'UNVERSIONED';
export const POTENTIAL_CONFLICT = 'POTENTIAL_CONFLICT';
export const CONFLICT = 'CONFLICT';
export const VERSIONED = 'VERSIONED';
export const LOCKED = 'LOCKED';
export const UPTODATE_NEEDED_ICON = 'UPTODATE_NEEDED_ICON';

//S3 Operation Constants
export const UPLOAD_FROM_COMPUTER = 'UPLOAD_FROM_COMPUTER';
export const UPLOAD_FROM_URL = 'UPLOAD_FROM_URL';
export const S3BUCKET = 'S3BUCKET';
export const PUBLIC_URL = 'PUBLIC_URL';
export const ZOOM_S3 = 'ZOOM_S3';
export const CUSTOM_S3 = 'CUSTOM_S3';

export const ORIGNAL_HI_RES = 'hi-res';
export const ZOOM_LOW_RES = 'proxy';
export const ORIGINAL = 'Original';

export const DUPLICATE_RENAME = 'RENAME';
export const DUPLICATE_SKIP = 'SKIP';
export const DUPLICATE_REPLACE = 'REPLACE';
export const DUPLICATE_ABORT = 'ABORT';
export const HIGH = 'HIGH';
export const LOW = 'LOW';
export const MIX = 'MIX';

export const FILE_EXTENSIONS = { video: ['mxf', 'mov', 'flv', 'wmv'] };

export const RESTORE_STATUS = {
  HI_RES: '_hiResArchiveStatus',
  MID_RES: '_midResArchiveStatus',
  LOW_RES: '_lowResArchiveStatus'
};

export const SMART_COPY_PREFIX = 'SMART_COPY_PREFIX';
export const SMART_LAST_SELECTED = 'SMART_LAST_SELECTED'; //Last Selected Smart copy and link Path
export const BACK_TO_BTN = {
  BACK_TO_SRCH: 'BACK_TO_SEARCH',
  ADVANCED_SRCH: 'ADVANCED SEARCH'
};

export const archiveStatusEnum = {
  VAB_ARCHIVED: 'A',
  VAB_NOT_ARCHIVED: 'N',
  VAB_NOT_APPLICABLE: 'NA',
  VAB_PENDING: 'P',
  VAB_TRUE_ARCHIVE: 'TA',
  VAB_COPIED_TO_ARCHIVE: 'CA'
};

export const archiveResolutions = {
  HI_RES: 'High-res',
  MID_RES: 'Mid-res',
  LOW_RES: 'Low-res',
  DIRECT: 'Direct'
};